import { isNull, isUndefined } from 'lodash/fp'
import Dependant from '@master/model/kyc-form/Dependant'
import Validation from '@core/logic/Validation'

export default class DependantValidation extends Validation {
  validate (dependant: Dependant, index: number, belongsTo: string) {
    this.belongsTo = belongsTo
    const isRequired = (!isNull(dependant.name) && !isUndefined(dependant.name) && !this.isEmpty(dependant.name))

    const { getMessages, ADD, REQUIRE, REQUIRE_NUMBER, WHEN } = this.validator()
    ADD(WHEN(isRequired, REQUIRE(dependant.nric, `Dependant ${index} nric must be filled when dependant name is supplied.`)), ['Dependants'], ['nric'], index)
    ADD(WHEN(isRequired, REQUIRE_NUMBER(dependant.dob, `Dependant ${index} date of birth must be filled when dependant name is supplied.`)), ['Dependants'], ['dob'], index)
    ADD(WHEN(isRequired, REQUIRE_NUMBER(dependant.age, `Dependant ${index} age must be filled when dependant name is supplied.`)), ['Dependants'], ['age'], index)
    ADD(WHEN(isRequired, REQUIRE(dependant.gender, `Dependant ${index} gender must be filled when dependant name is supplied.`)), ['Dependants'], ['gender'], index)
    ADD(WHEN(isRequired, REQUIRE(dependant.yearsSupport, `Dependant ${index} years of support must be filled when dependant name is supplied.`)), ['Dependants'], ['yearsSupport'], index)
    ADD(WHEN(isRequired, REQUIRE(dependant.relationship, `Dependant ${index} relationship must be filled when dependant name is supplied.`)), ['Dependants'], ['relationship'], index)
    return getMessages()
  }
}
